import { Button, Wrap, WrapItem } from '@chakra-ui/react';
import React from 'react';

interface Dosage {
  id: string;
  label: string;
  defaultQuantity: number;
  priceMultiplier: number;
}

interface Drug {
  id: string;
  name: string;
  dosages: Dosage[];
  selectedDosage?: Dosage;
}

interface SuggestedDrugsProps {
  suggestedDrugs: Drug[];
  onDrugSelect: (drug: Drug) => void;
}

const SuggestedDrugs: React.FC<SuggestedDrugsProps> = ({ suggestedDrugs, onDrugSelect }) => {
  const handleChipClick = (drug: Drug) => {
    // If the drug has dosages, select the first one by default
    // This matches the behavior expected by handleDrugSelect in the parent
    if (drug.dosages && drug.dosages.length > 0) {
      onDrugSelect({ ...drug, selectedDosage: drug.dosages[0] });
    } else {
      // Fallback if no dosages, though this shouldn't happen with valid drug data
      onDrugSelect(drug);
    }
  };

  if (!suggestedDrugs || suggestedDrugs.length === 0) {
    return null;
  }

  return (
    <Wrap spacing="10px" justify="center" mt={4} mb={2}>
      {suggestedDrugs.map((drug) => (
        <WrapItem key={drug.id}>
          <Button size="sm" variant="outline" colorScheme="teal" onClick={() => handleChipClick(drug)}>
            {drug.name}
          </Button>
        </WrapItem>
      ))}
    </Wrap>
  );
};

export default SuggestedDrugs;
